<template>
  <Modal
    :cancelFunction="closeModal"
    :isSaving="isSaving"
    :okFunction="addColorScheme"
    :modalStyles="{ width: '400px', height: '670px' }"
    title="Add Brand Color"
  >
    <template v-slot:body>
      <div class="group-body">
        <div class="form-group">
          <label for="colorName" class="label">Custom Name </label>
          <input
            class="form-control"
            type="text"
            id="colorName"
            placeholder="Name of Color"
            v-model="colorName"
            required
          />
        </div>
        <div class="form-group">
          <label for="colorCode">
            <div class="label">Color Code</div>
            <ColorPicker v-model="colorCode" />
          </label>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
  import Modal from '@/components/common/Modal.vue';
  import { apiPostOrganisationScheme, apiUserPostOrganisationScheme } from '@/api/organisation';
  import ColorPicker from '@/components/ColorPicker.vue';

  export default {
    name: 'AddColorModal',

    components: { Modal, ColorPicker },

    data() {
      return {
        colorName: '',
        colorCode: '#000000',
        isSaving: false,
      };
    },

    computed: {
      organisationIdParam() {
        return this.$route.params.organisation_id;
      },
      isAdmin() {
        return this.$store.getters.isAdministrator;
      },
    },

    methods: {
      async addColorScheme() {
        if (!this.colorName) {
          this.$toasted.global.general_error({ message: 'Name is required' });
          return;
        }
        this.isSaving = true;
        try {
          const newScheme = {
            type: 'color',
            name: this.colorName,
            config: { color: this.colorCode },
          };
          let response;
          if (this.isAdmin) {
            let orgID = this.organisationIdParam;
            response = await apiPostOrganisationScheme(orgID, newScheme);
          } else {
            response = await apiUserPostOrganisationScheme(newScheme);
          }

          this.$toasted.global.general_success({
            message: 'Color scheme added successfully',
          });
          this.$emit('schemeAdded', response.data);
          this.closeModal();
        } catch (error) {
          this.$toasted.global.general_error({ message: 'Failed to add color scheme' });
        } finally {
          this.isSaving = false;
        }
      },
      closeModal() {
        this.$emit('close');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .group-body {
    display: grid;
    row-gap: 24px;
    column-gap: 16px;

    .form-group {
      width: 100%;
      margin-bottom: 0px;
      display: flex;
      flex-direction: column;
      margin-bottom: 0;
      gap: 8px;
    }

    label {
      width: 100%;
      font-weight: 500;
      font-size: 14px;
      line-height: 24px;
      margin-bottom: 0;
    }

    input.form-control {
      width: 100%;
      padding: 6px 16px;
      height: auto;
      border: 2px solid $borderGrey;
      border-radius: 8px;
      font-size: 16px;
      line-height: 24px;
      color: #151515;

      &:focus {
        box-shadow: none;
        border-color: #696969;
      }
    }
    .input-group-prepend {
      width: 18px;
      height: 18px;
      border-radius: 4px;
      box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.25);
    }
  }
</style>
